// extracted by mini-css-extract-plugin
module.exports = {"container":"OfsDeliveryTypes_container__2ChRb"};